module.exports = __webpack_public_path__ + "img/30.b9af751e.jpg";